import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';



class MagnetismFormulas extends React.Component{

  render(){
    return(
      <MuiThemeProvider>

        <div style = {{paddingBottom: 40}}>

        <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderColumn style = {{width: 450}}>Uses</TableHeaderColumn>
        <TableHeaderColumn>Formula</TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody>
      <TableRow>
        <TableRowColumn style = {{width: 430}}>Magnetic field (from straight wire)</TableRowColumn>
        <TableRowColumn> <img style = {{paddingRight: 100}} src = {require("./Formulas/1.png")} /> </TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 430}}>Magnetic field (from loop wire)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/2.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 430}}>Magnetic Force (on moving point charge)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/3.png")} /></TableRowColumn>
      </TableRow>
      <TableRow>
        <TableRowColumn style = {{width: 430}}>Magnetic Force (on current-carrying wire)</TableRowColumn>
        <TableRowColumn><img style = {{paddingRight: 100}} src = {require("./Formulas/4.png")} /></TableRowColumn>
      </TableRow>
    </TableBody>
  </Table>

</div>


      </MuiThemeProvider>

    );
  }
}

export default MagnetismFormulas;



// WEBPACK FOOTER //
// ./src/Physics/Magnetism/MagnetismFormulas.js